module.exports = __webpack_public_path__ + "static/media/progress-chart-img.f30d8767.webp";